import { types as api } from '@mesa-labs/mesa-api';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareHeaders, useExternalVendorApi } from './api';

export const externalVendorsApi = createApi({
  reducerPath: 'externalVendorsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: CONFIG.api.externalVendorUrl,
    prepareHeaders,
  }),
  tagTypes: ['VendorHistoricalInvoiceTotals', 'VendorTopClients', 'VendorInvoices', 'VendorApprovalStatusTotals'],
  endpoints: (build) => ({
    getVendorHistoricalInvoiceTotals: build.query<api.VendorHistoricalInvoiceTotalsResponse, api.VendorHistoricalInvoiceTotalsFilterParams & { partnerId: api.Partners, vendorId: api.UUID }>({
      async queryFn({ partnerId, vendorId, ...params }, { dispatch }) {
        const externalVendorApi = useExternalVendorApi(dispatch);
        const data = await externalVendorApi.getVendorHistoricalInvoiceTotals(partnerId, vendorId, params);
        return { data };
      },
      providesTags: ['VendorHistoricalInvoiceTotals'],
    }),
    getVendorTopClients: build.query<api.VendorTopClientsResponse, api.VendorTopClientsFilterParams & { partnerId: api.Partners, vendorId: api.UUID }>({
      async queryFn({ partnerId, vendorId, ...params }, { dispatch }) {
        const externalVendorApi = useExternalVendorApi(dispatch);
        const data = await externalVendorApi.getVendorTopClients(partnerId, vendorId, params);
        return { data };
      },
      providesTags: ['VendorTopClients'],
    }),
    getVendorInvoices: build.query<api.IPagedResults<api.ExternalInvoiceDataResponse>, api.VendorInvoicesFilterParams & { partnerId: api.Partners, vendorId: api.UUID }>({
      async queryFn({ partnerId, vendorId, ...params }, { dispatch }) {
        const externalVendorApi = useExternalVendorApi(dispatch);
        const data = await externalVendorApi.getVendorInvoices(partnerId, vendorId, params);
        return { data };
      },
      providesTags: ['VendorInvoices'],
    }),
    getVendorApprovalStatusTotals: build.query<api.VendorApprovalStatusTotalsResponse, { partnerId: api.Partners, vendorId: api.UUID }>({
      async queryFn({ partnerId, vendorId }, { dispatch }) {
        const externalVendorApi = useExternalVendorApi(dispatch);
        const data = await externalVendorApi.getVendorApprovalStatusTotals(partnerId, vendorId);
        return { data };
      },
      providesTags: ['VendorApprovalStatusTotals'],
    }),
  }),
});

export const {
  useGetVendorHistoricalInvoiceTotalsQuery,
  useGetVendorTopClientsQuery,
  useGetVendorInvoicesQuery,
  useGetVendorApprovalStatusTotalsQuery,
} = externalVendorsApi;
